import * as Actions from '../actions';

const initialState = {
  loading: false,
  success: false,
  error: {
    username: null,
    password: null
  }
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case Actions.LOGIN_LOADING: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case Actions.LOGIN_SUCCESS: {
      return {
        ...initialState,
        success: true
      };
    }
    case Actions.LOGIN_ERROR: {
      return {
        success: false,
        error: 'Test erorr'
      };
    }
    default: {
      return state;
    }
  }
};

export default login;
